import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CaseCreationState {
  active: boolean;
  jobId: string | null;
}

const initialState: CaseCreationState = {
  active: false,
  jobId: null,
};

const caseCreationSlice = createSlice({
  name: 'caseCreation',
  initialState,
  reducers: {
    startCaseCreationProgress: (state, action: PayloadAction<{ jobId: string }>) => {
      state.active = true;
      state.jobId = action.payload.jobId;
    },
    endCaseCreationProgress: (state) => {
      state.active = false;
      state.jobId = null;
    },
  },
});

export const { startCaseCreationProgress, endCaseCreationProgress } = caseCreationSlice.actions;
export default caseCreationSlice.reducer;